import { useLayoutEffect, useRef } from 'react'
import {
  reportActualUIRendered,
  getSsrExperiments,
} from '../helpers/ssr-experiments-store'

const reportUI = (
  experimentName: string,
  renderedVariant: boolean,
  createBAUIfMissing: boolean,
): void => {
  const experiment = getSsrExperiments().find(
    (exp) => exp.name === experimentName,
  )
  const hasRealAssignment = experiment && !experiment.isBAU

  if (hasRealAssignment) {
    reportActualUIRendered(
      experimentName,
      renderedVariant ? 'Variant' : 'Control',
    )
  } else if (createBAUIfMissing && !experiment) {
    // Create BAU entry to track that UI rendered without Target assignment
    reportActualUIRendered(experimentName)
  }
}

export const useReportExperimentUI = (
  experimentName: string,
  renderedVariant: boolean,
): void => {
  const hasReportedRef = useRef(false)

  // Report synchronously on first render to ensure it happens before analytics fires
  if (!hasReportedRef.current) {
    reportUI(experimentName, renderedVariant, true)
    hasReportedRef.current = true
  }

  // Also update in effect for subsequent renders
  useLayoutEffect(() => {
    reportUI(experimentName, renderedVariant, false)
  }, [experimentName, renderedVariant])
}
